export const utils = {
  strZero (valor, tamanho) {
    if (!valor) {
      return ''
    }

    if (isNaN(Number(valor))) {
      return ''
    }

    return valor.toString().padStart(tamanho, '0')
  },

  ordenarArrayNumericamente (array) {
    return array.sort(compararNumeros)

    function compararNumeros (a, b) {
      return a - b
    }
  },

  formatarCampoDataParaEnvioAoBackend (data) {
    if (data && this.isDataValida(new Date(data))) {
      return new Date(data).toISOString()
    }
  },

  formatarCampoDataParaEnvioAoBackendSemHora (data) {
    if (data && this.isDataValida(new Date(data))) {
      return new Date(data).toISOString().slice(0, 10);
    }
  },

  isObject (object) {
    return typeof object == "object" && !Array.isArray(object) && object !== null
  },

  converterStringParaKebab(string) {
    let stringTratada = string;
    stringTratada = stringTratada.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    stringTratada = stringTratada.replace(
      /[_\[\]]/g,
      '');
    stringTratada = stringTratada.replace(
      /[A-Z]+(?![a-z])|[A-Z]|[_\[\]]/g,
      ($, ofs) => (ofs ? "-" : "") + $.toLowerCase()
    );
    stringTratada = stringTratada.replace(" -", "-");
    stringTratada = stringTratada.replace(" ", "-");
    return stringTratada;
  },

  formatarDataAsStringToYyyyMmDd(data) {
    if(data == null) {
      return null;
    }

    return `${data}`.replace(/([0-9]{2})\/([0-9]{2})\/([0-9]{4})/, '$3-$2-$1');
  },

  formatarDataParaExibicao (data) {
    if (data && this.isDataValida(new Date(data))) {
      return data.substring(0, 10)
    } else {
      return null
    }
  },

  formatarDataParaExibicaoMesAno (data) {
    if (data && this.isDataValida(new Date(data))) {
      return this.formatarDataParaExibicao(data).substring(3, 10)
    }
  },

  formatarDataParaExibicaoNoDataTable (data) {
    if (data && this.isDataValida(new Date(data))) {
      const dataObj = new Date(data);

      const formatador = new Intl.DateTimeFormat('pt-br', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
      });

      return formatador.format(dataObj);
    }
  },
  

  isDataValida (data) {
    return data instanceof Date && !isNaN(data)
  },

  formatarStringToDate(data, plusDay = 0, plusMonth = 0, plusYear = 0) {
    let dataFormatada = data.split("/"); 
    dataFormatada = new Date(parseInt(dataFormatada[2]) + plusYear, parseInt(dataFormatada[1]) - 1 + plusMonth, parseInt(dataFormatada[0]) + plusDay, 0, 0, 0, 0); 
    return dataFormatada;
  },

  subtrairMesDeUmaData(data, mes) {
    data.setUTCMonth(data.getUTCMonth() - mes);
    return data;
  },

  toUtcIsoString (date) {
    date.setUTCHours(0)
    date.setUTCMinutes(0)
    date.setUTCSeconds(0)
    date.setUTCMilliseconds(0)

    return date.toISOString()
  },

  isTelefone (telefone) {
    if (telefone) {
      const er = new RegExp(/^\(?\d{2}\)?[\s-]?[\s9]?\d{4,5}-?\d{4}$/)
      if (!er.test(telefone) && telefone.length !== 0) {
        return false
      }
    }

    return true
  },

  isEmail (email) {
    if (email) {
      const er = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)?$/
      if (!er.test(email)) {
        return false
      }
    }

    return true
  },

  onlynumber (evt) {
    var theEvent = evt || window.event
    var key = theEvent.keyCode || theEvent.which
    key = String.fromCharCode(key)
    var regex = /^[0-9.]+$/
    if (!regex.test(key)) {
      theEvent.returnValue = false
      if (theEvent.preventDefault) theEvent.preventDefault()
    }
  },

  ordenarDeFormaCrescente(array) {
      array.sort(function (a, b) {
        if (a.nome < b.nome) {
          return -1;
        } else {
          return true;
        }
      });
  },

  async retry(validation, time, attempt = 1, maxTrys = 5) {
    if(attempt > maxTrys) return false;
    const wait = await new Promise(resolve => setTimeout(resolve, time));
    const isValid = validation();
    return isValid? isValid : await this.retry(validation, time, attempt+1, maxTrys);
  },

  valueMaskToNumber(valor) {
    if(!valor) return null;
    const sValor = valor.toString();

    let valorFormatado = sValor;
    if(sValor.includes(',')) {
      valorFormatado = sValor.replaceAll('.', '').replaceAll(',', '.');
    }
    
    return Number(valorFormatado).toFixed(2);
  }
}
